import { Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';

import { type ListingDetails } from './listingDetails';

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const SummaryCard = ({
  listing,
  offerCents,
  continueLabel,
  onContinue,
  analyticsName,
  continueDisabled = false,
}: {
  listing: ListingDetails;
  offerCents: number | null | undefined;
  continueLabel: string;
  onContinue: () => void;
  analyticsName: string;
  /** Blocks the step's action while its answers are incomplete. */
  continueDisabled?: boolean;
}) => {
  return (
    <Col
      as="section"
      aria-label="Offer summary"
      className="w-full gap-6 rounded-[16px] bg-od-bg-secondary p-4 lg:sticky lg:top-6 lg:w-[267px] lg:shrink-0"
    >
      <Col className="gap-4">
        <Col className="gap-1">
          <Row className="justify-between">
            <Text className="text-body-md text-od-content-secondary">List price</Text>
            <Text className="text-body-md text-od-content-primary">
              {listing.listingPriceCents != null
                ? usd.format(listing.listingPriceCents / 100)
                : '-'}
            </Text>
          </Row>
          <Row className="justify-between">
            <Text className="font-medium text-body-md text-od-content-secondary">Offer amount</Text>
            <Text className="font-medium text-body-md text-od-content-primary">
              {offerCents != null && offerCents > 0 ? usd.format(offerCents / 100) : '-'}
            </Text>
          </Row>
        </Col>
        <Col className="gap-2">
          <Button
            type="button"
            variant="primary"
            onClick={onContinue}
            disabled={continueDisabled}
            className="w-full rounded-[12px] disabled:cursor-default"
            aria-label={continueLabel}
            analyticsName={analyticsName}
          >
            {continueLabel}
          </Button>
        </Col>
      </Col>
    </Col>
  );
};
